import { Routes, UrlMatcher, UrlSegment } from '@angular/router';
import { AngebotNichtGefundenComponent } from './pages/angebot-nicht-gefunden/angebot-nicht-gefunden.component';
import { ErrorComponent } from './pages/error/error.component';
import { Error404Component } from './pages/error404/error404.component';
import { SucheComponent } from './pages/suche/suche.component';
import { ThemenfelderPageComponent } from './pages/themenfelder/themenfelder-page.component';
import { detailseiteResolver } from './resolver/detailseite.resolver';

const detailseite: UrlMatcher = (url: UrlSegment[]) =>
  url.length === 2 && url[0].path === 'termin'
    ? { consumed: url, posParams: { id: url[1] } }
    : null;

export const APP_ROUTES: Routes = [
  {
    // Homescreen / Startseite
    path: '',
    pathMatch: 'full',
    component: SucheComponent
  },
  {
    matcher: detailseite,
    // See https://angular.io/api/router/Resolve#:~:text=See%20more...-,Deprecated,-%3A%20Class%2Dbased
    resolve: { termin: detailseiteResolver },
    loadChildren: () => import('./pages/detail/detail.routes').then((m) => m.DETAIL_ROUTES)
  },
  {
    path: '404',
    component: Error404Component
  },
  {
    path: 'angebot-nicht-gefunden',
    component: AngebotNichtGefundenComponent
  },
  {
    path: 'error',
    component: ErrorComponent
  },
  { path: 'themenfelder', component: ThemenfelderPageComponent },
  { path: '**', redirectTo: '404', pathMatch: 'full' }
];
